import { render, staticRenderFns } from "./MenuAdminItem.vue?vue&type=template&id=8a808f98&"
import script from "./MenuAdminItem.vue?vue&type=script&lang=js&"
export * from "./MenuAdminItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports